import exponent from "./exponent";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-format/src/precisionFixed.js
// module id = ../../../../d3-format/src/precisionFixed.js
// module chunks = 4